// extracted by mini-css-extract-plugin
var _1 = "UserNotificationSettingsTable-module__animateUploadProgressBarWidth--NDNoP";
var _2 = "UserNotificationSettingsTable-module__animatedBackground--T6B6m";
var _3 = "UserNotificationSettingsTable-module__items--kUJTu";
var _4 = "UserNotificationSettingsTable-module__platformHeadings--VU2GU";
var _5 = "UserNotificationSettingsTable-module__scopeContainer--CcGon";
var _6 = "UserNotificationSettingsTable-module__toggleContainer--klcVs";
var _7 = "UserNotificationSettingsTable-module__toggles--SyLBP";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "items", _4 as "platformHeadings", _5 as "scopeContainer", _6 as "toggleContainer", _7 as "toggles" }
